// extracted by mini-css-extract-plugin
export default {"colsServices":"ServicesBody-module__[local]___GpYLI","wrapper":"ServicesBody-module__[local]___-xgwd"};